<template>
  <div>
    <div class="date-input" @click="openDatepicker">
      Effective date :
      <input type="date" class="date-picker"
        :value="value"
        @input="onInput"
        @change="onChange"
        :format="format"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    value: {
      type: [String, Date],
      default: ''
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  methods: {
    openDatepicker() {
      const dateInput = this.$el.querySelector('.date-picker');
      if (dateInput) {
        dateInput.focus();
        dateInput.showPicker ? dateInput.showPicker() : dateInput.click();
      }
    },
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onChange(event) {
      this.$emit('change', event.target.value);
      this.$emit('input', event.target.value);
    }
  }
};
</script>

<style scoped>
.filter-label {
  font-size: 12px;
  color: #ddd;
  margin-left: 5px;
}

.date-input {
  background: white;
  border-radius: 6px;
  padding: 0.7rem 12px;
  display: flex;
  align-items: center;
  width: 260px;
  justify-content: space-between;
  border: 1px solid #ced4da;
  cursor: pointer;
  position: relative;
}

.hidden-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}
.date-picker{
  border: none;
}
@media (max-width:519px) {
  .date-input{
    width: max-content;
  }
}
</style>